var render = function render(){
  var _vm$rules$_vm$PERSON$, _vm$rules$_vm$PERSON$2, _vm$rules$_vm$PERSON$3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "height": "100%"
    }
  }, [_c('v-form', {
    staticClass: "pa-16",
    staticStyle: {
      "height": "100%",
      "overflow": "auto"
    },
    model: {
      value: _vm.isValid,
      callback: function ($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "아이디",
      "rules": _vm.rules.username,
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.inputs.username,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "username", $$v);
      },
      expression: "inputs.username"
    }
  }), _c('v-password-field', {
    attrs: {
      "label": "비밀번호",
      "rules": _vm.rules.password,
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.inputs.password,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "password", $$v);
      },
      expression: "inputs.password"
    }
  }), _c('v-password-confirm-field', {
    attrs: {
      "label": "비밀번호확인",
      "password": _vm.inputs.password,
      "outlined": "",
      "dense": ""
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "이름",
      "rules": (_vm$rules$_vm$PERSON$ = _vm.rules[_vm.PERSON.value]) === null || _vm$rules$_vm$PERSON$ === void 0 ? void 0 : _vm$rules$_vm$PERSON$.name,
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.inputs.name,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "name", $$v);
      },
      expression: "inputs.name"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "생년월일",
      "type": "date",
      "max": "2999-12-31",
      "rules": (_vm$rules$_vm$PERSON$2 = _vm.rules[_vm.PERSON.value]) === null || _vm$rules$_vm$PERSON$2 === void 0 ? void 0 : _vm$rules$_vm$PERSON$2.bornAt,
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.inputs.bornAt,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "bornAt", $$v);
      },
      expression: "inputs.bornAt"
    }
  }), _c('v-select', {
    attrs: {
      "label": "성별",
      "items": _vm.genders,
      "rules": (_vm$rules$_vm$PERSON$3 = _vm.rules[_vm.PERSON.value]) === null || _vm$rules$_vm$PERSON$3 === void 0 ? void 0 : _vm$rules$_vm$PERSON$3.gender,
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.inputs.gender,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "gender", $$v);
      },
      expression: "inputs.gender"
    }
  }), _c('user-contact-certification', {
    attrs: {
      "outlined": "",
      "dense": "",
      "btnAttrs": {
        color: 'primary',
        width: 100,
        height: 50,
        className: 'mt-n8'
      }
    },
    model: {
      value: _vm.inputs.phone,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "phone", $$v);
      },
      expression: "inputs.phone"
    }
  }), _c('terms-of-agreements-short', {
    on: {
      "isValid": function (isValid) {
        return _vm.isTermsValid = isValid;
      }
    },
    model: {
      value: _vm.inputs._terms,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "_terms", $$v);
      },
      expression: "inputs._terms"
    }
  })], 1), _c('v-btn', {
    staticClass: "primary white--text",
    attrs: {
      "disabled": !_vm.isValid,
      "x-large": "",
      "block": "",
      "tile": ""
    },
    on: {
      "click": _vm.join
    }
  }, [_vm._v("회원가입")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }